import type { SVGProps } from 'react';
import * as React from 'react';

const ArrowTopRightOnSquareIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/arrow-top-right-on-square">
      <g id="Icon">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.10002 6.59999C4.60297 6.59999 4.20002 7.00294 4.20002 7.49999V17.7C4.20002 18.1971 4.60297 18.6 5.10002 18.6H15.3C15.7971 18.6 16.2 18.1971 16.2 17.7V12.9C16.2 12.4029 16.603 12 17.1 12C17.5971 12 18 12.4029 18 12.9V17.7C18 19.1912 16.7912 20.4 15.3 20.4H5.10002C3.60886 20.4 2.40002 19.1912 2.40002 17.7V7.49999C2.40002 6.00883 3.60886 4.79999 5.10002 4.79999H11.1C11.5971 4.79999 12 5.20294 12 5.69999C12 6.19705 11.5971 6.59999 11.1 6.59999H5.10002Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.43264 15.3038C7.76612 15.6724 8.33526 15.7009 8.70385 15.3674L19.8 5.32798V8.69999C19.8 9.19705 20.203 9.59999 20.7 9.59999C21.1971 9.59999 21.6 9.19705 21.6 8.69999V3.29999C21.6 2.80294 21.1971 2.39999 20.7 2.39999H15.3C14.803 2.39999 14.4 2.80294 14.4 3.29999C14.4 3.79705 14.803 4.19999 15.3 4.19999H18.3638L7.4962 14.0326C7.12762 14.3661 7.09916 14.9352 7.43264 15.3038Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default ArrowTopRightOnSquareIcon;
